<div class="tw-placeholder">
  <div class="tw-placeholder__icon tw-placeholder__icon--{{ size }}" [ngSwitch]="type">
    <mat-icon *ngSwitchCase="'info'">error</mat-icon>
    <mat-icon *ngSwitchCase="'error'">cancel</mat-icon>
    <mat-icon *ngSwitchCase="'empty'">help</mat-icon>
    <mat-icon *ngSwitchCase="'inspect'">manage_search</mat-icon>
  </div>
  <ng-content></ng-content>
</div>
